import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Button, Label, Alert } from "reactstrap";
import Page from "components/Page";
import { Checkbox } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchDataCarritoHogar, FetchDataSeccionesCoberturasHogar, FetchDataCoberturasHogarAdvance } from "../../redux/actions/ACarritoProductos";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { obtenerDatosHogar } from '../../utils/validaciones';

class CotizacionProteccionesPaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrayProtecciones: undefined,
      productoActual: undefined,
      datosHogar: obtenerDatosHogar(null),
    };
  }



  onValidateform = async () => {
    let { arrayProtecciones, productoActual } = this.state;
    const queryParams = new URLSearchParams(this.props.location.search);
    const codEdicion = queryParams.get('codEdicion');
    let codProductoActual = this.props.carrito.carCodigoProductoActual
    if (codEdicion !== undefined && codEdicion !== '' && codEdicion !== null) {
      codProductoActual = codEdicion
    }
    //Datos a enviar al carrito
    const datosCarrito = {
      empresa: "AIGMETROPOLITANA",
      protecciones: arrayProtecciones,
      mongoCarrito: this.props.carrito.mongoCarrito,
      pasoCarrito: "protecciones",
      codigo: codProductoActual
    }
    await this.props.cargarCoberturasHogarAdvance();
    console.log(JSON.stringify('datosCarrito',datosCarrito))
    await this.props.setCarrito(datosCarrito);
    if (this.props.carritoload.carritoHogarError === false) {
      //Verificar si el producto tiene valores calculados
      if (productoActual && productoActual.coberturas && productoActual.totales) {
        const queryParams = new URLSearchParams(this.props.location.search);
        const codEdicion = queryParams.get('codEdicion');
        if (codEdicion === '' || codEdicion === null) {
          this.props.history.push({
            pathname: "/cotizacion-hogar-paso4",
            search: `?recuperar=true${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}`
          });
        }
        else {
          this.props.history.push({
            pathname: "/cotizacion-hogar-paso4",
            search: `?recuperar=true&codEdicion=${codEdicion}${this.state.datosHogar.codig != null ? "&producto=" + this.state.datosHogar.codig : ""}`
          });
        }
      }
      else {
        //Precargar las secciones para los cálculos
        let datosCarritoHogar =
        {
          "empresa": "AIGMETROPOLITANA",
          "idCarrito": this.props.carrito.mongoCarrito
        }
        await this.props.cargarSeccionesCoberturas(datosCarritoHogar);
       

        const queryParams = new URLSearchParams(this.props.location.search);
        const codEdicion = queryParams.get('codEdicion');
        if (codEdicion === '' || codEdicion === null) {
          //Redireccionar paso 4
          this.props.history.push(
            {
               pathname: "/cotizacion-hogar-paso4",
               search: this.state.datosHogar.codigo != null
                ? "?producto=" + this.state.datosHogar.codigo
                : "",
              
              }
            );
        }
        else {
          this.props.history.push({ pathname: "/cotizacion-hogar-paso4", search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}` });
        }


      }
    }

  }

  onRegresar = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const codEdicion = queryParams.get('codEdicion');
    if (codEdicion === "" || codEdicion === null) {
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso2",
        search: this.state.datosHogar.codigo != null
          ? "?producto=" + this.state.datosHogar.codigo
          : "",
      });
    }
    else {
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso2",
        search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}`, //agregar parametros de la url,
      });
    }

  }

  componentDidMount() {
    if (this.props.carrito && this.props.carrito.carProductos) {


      let producto = null
      let seguro = this.props.carrito.carDescripcionSeguro;
  
      switch (seguro) {
        case 'HOGAR AIG':
          producto = 'hogar-aig'
          break;
  
        case 'HOGAR ADVANCE':
          producto = 'advance'
          break;
  
        default:
          break;
      }
  
      this.setState({ datosHogar: obtenerDatosHogar(producto) })
      
      const queryParams = new URLSearchParams(this.props.location.search);
      const codEdicion = queryParams.get('codEdicion');
      let codProductoActual = this.props.carrito.carCodigoProductoActual
      if (codEdicion !== undefined && codEdicion !== '' && codEdicion !== null) {
        codProductoActual = codEdicion
      }
   
      //Obtener Producto actual
      let ObtenerProductoActual = this.props.carrito.carProductos.filter((item) =>
        item.codigo === codProductoActual
      )
      ObtenerProductoActual = ObtenerProductoActual[0];
      if (ObtenerProductoActual && ObtenerProductoActual !== '' && ObtenerProductoActual.protecciones) {
        this.setState({ arrayProtecciones: ObtenerProductoActual.protecciones, productoActual: ObtenerProductoActual });
      }
      else {
        this.inicializarArrayProtecciones();
      }
    }

  }

  inicializarArrayProtecciones() {
    if (this.props.proteccionesArray) {
      //inicializar el estado del array de protecciones
      let ObtenerProtecciones = this.props.proteccionesArray;
      ObtenerProtecciones.forEach((element, i) => {
        ObtenerProtecciones[i] = { ...ObtenerProtecciones[i], proteccionSelected: false, proteccionValorEmision: 0 }
      });
      this.setState({ arrayProtecciones: ObtenerProtecciones });
    }
  }

  render() {
    let { arrayProtecciones } = this.state;
    return (
      <LoadingScreen
        loading={this.props.carritoload.carritoHogarloading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Page title={this.state.datosHogar.titulo} breadcrumbs={[{ name: this.state.datosHogar.titulo, active: true }]}>

          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12} className="mb-3">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'>Protecciones de la Vivienda</h4>
                  <Row>
                    <Col lg={3} md={2} sm={2} xs={2}></Col>
                    <Col lg={6} md={8} sm={8} xs={8}>
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Especifique si la vivienda posee o no los siguientes elementos.</Label></h5></Col>
                      </Row>
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          {arrayProtecciones && arrayProtecciones.map((seccion, i) => {
                            return (
                              <Row key={i}>
                                <Col lg={6} md={6} sm={8} xs={8}>
                                  {seccion.name}
                                </Col>
                                <Col lg={6} md={6} sm={4} xs={4}>
                                  <Checkbox
                                    id={seccion.name + i} // Optional.[String].Default: "".  Input ID.
                                    name={seccion.name + i} // Optional.[String].Default: "". Input name
                                    value={seccion.proteccionSelected} // Required.[String].Default: "".
                                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    checked={seccion.proteccionSelected} // Required.[Bool].Default: false.
                                    classNameInputBox={'check-uber'}
                                    onChange={(proteccion, e) => {
                                      let valor = proteccion ? -1 : 0;
                                      arrayProtecciones[i] = { ...arrayProtecciones[i], proteccionSelected: proteccion, proteccionValorEmision: valor }
                                      this.setState({ arrayProtecciones })
                                    }}

                                    validationOption={{
                                      name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                      check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: false // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }}
                                  />
                                </Col>
                              </Row>
                            );
                          })}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={3} md={2} sm={2} xs={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div style={{ textAlign: "center" }}>
                        <Button className={"button-white"} onClick={this.onRegresar}>
                          <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                          REGRESAR
                        </Button>
                        {"   "}
                        <Button onClick={this.onValidateform} className="btn btn-primary" >
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`}
                        </Button>
                        <p></p>
                        {this.props.carritoload.carritoHogarError &&
                          <Alert color="danger" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                            <center><p>Ha ocurrido un inconveniente al guardar la información. Por favor intente nuevamente.</p></center>
                          </Alert>
                        }
                      </div>
                    </Col>
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>


        </Page>
      </LoadingScreen>
    );
  }
};

const mapStateToProps = state => ({
  carrito: state.datosCarritoHogar.setCarritoHogar,
  proteccionesArray: state.catalogosHogar.setRelatividadesHogar.protecciones,
  carritoload: state.datosCarritoHogar
});

const mapDispatchToProps = dispatch => {
  return {
    setCarrito: (datosCarrito) => dispatch(FetchDataCarritoHogar(datosCarrito)),
    cargarSeccionesCoberturas: (param) => dispatch(FetchDataSeccionesCoberturasHogar(param)),
    cargarCoberturasHogarAdvance: () => dispatch(FetchDataCoberturasHogarAdvance()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionProteccionesPaso3)
);
